import dayjs from "dayjs";
import request from "./index";
import { CRUISE } from "store/constants/destinationInBlocks";
import { AYANA_LAKODIA_ID } from "store/constants/hotel";

type GetCalendarRatesParams = {
  date_from: string; // YYYY-MM-DD
  date_to: string; // YYYY-MM-DD
  location_code?: string; // Bali
  room_type_id?: string | number; // 2
  hotel_code_id?: string | number; // 1 or 2 as we dont have filters in website, remember to update this if we introduce filters for property
};

type DateRate = {
  rate: {
    formatted: string;
    amount: number;
  };
};

export type DateRateFomatted = {
  rate: {
    formatted: string;
    amount: number;
    isLowest: boolean;
  };
};

type GetCalendarRatesResponse = {
  data: Record<string, DateRate>;
};

const updateData = (data: Record<string, DateRate>) => {
  const monthlyAmounts: Record<string, number> = {};
  const updatedData: Record<string, DateRateFomatted> = {};

  // Calculate the lowest amount for each month
  for (const date in data) {
    const parsedDate = dayjs(date);
    const yearMonth = parsedDate.format("YYYY-MM");

    const amount = data[date].rate.amount;
    if (!monthlyAmounts[yearMonth] || amount < monthlyAmounts[yearMonth]) {
      monthlyAmounts[yearMonth] = amount;
    }
  }

  //Create a new object with updated "formatted" values and "isLowest"
  for (const date in data) {
    const parsedDate = dayjs(date);
    const yearMonth = parsedDate.format("YYYY-MM");
    const amount = data[date].rate.amount;
    const formatted = data[date].rate.formatted;
    const isLowest = amount === monthlyAmounts[yearMonth];
    updatedData[date] = { rate: { amount, formatted, isLowest } };
  }

  return updatedData;
};

export const getCalendarRates = async ({
  location_code,
  hotel_code_id,
  room_type_id,
}: GetCalendarRatesParams) => {
  const start = dayjs().format("YYYY-MM-DD");
  const end = dayjs().add(1, "year").format("YYYY-MM-DD");

  // Do not fetch calendar rates for Ayana Lakodia
  if (
    (location_code === CRUISE && hotel_code_id === AYANA_LAKODIA_ID) ||
    hotel_code_id === AYANA_LAKODIA_ID
  ) {
    return;
  }

  const data = await request.get<GetCalendarRatesResponse>(
    "/api/v1/calendar.json",
    {
      params: {
        date_from: start,
        date_to: end,
        //due to uneven use of word casing in the CMS/UI, we need to capitalize the first letter and lowercase the rest
        location_code:
          location_code &&
          `${location_code[0].toUpperCase()}${location_code
            .slice(1)
            .toLowerCase()}`,
        "hotel_id[]": hotel_code_id,
        room_type_id,
      },
    }
  );

  const convetedRateRespose = updateData(data.data.data);

  return convetedRateRespose;
};
